'use client';

import { createContext } from 'react';

import type { ToggleButtonGroupContextInterface } from '../types/toggle-button-group.types';

export const ToggleButtonGroupContext = createContext<ToggleButtonGroupContextInterface>({});

ToggleButtonGroupContext.displayName = 'ToggleButton.Group.Context';
